import React, { useEffect } from 'react'

import { PlaidLinkOptions, usePlaidLink } from 'react-plaid-link'

interface PlaidLinkProps {
  config: PlaidLinkOptions
}

export const PlaidLink: React.FC<PlaidLinkProps> = ({ config }) => {
  const { open, ready } = usePlaidLink(config)

  useEffect(() => {
    ready && open()
  }, [ready, open])

  return null
}
